import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-item/project/project.module.css";

export default {
  "projectBackground": "project-module__projectBackground_t1863W__100",
  "projectTop": "project-module__projectTop_t1863W__100",
  "projectWrapper": "project-module__projectWrapper_t1863W__100"
};
      